export const CHART_COLORS = {
  currentYear: '#10B981',
  palette: {
    dark: ['#10B981', '#3B82F6', '#F97316', '#60A5FA', '#A78BFA', '#F472B6'],
    light: ['#10B981', '#3B82F6', '#F97316', '#1F2937', '#9CA3AF', '#6B7280'],
  },
  previousYear: {
    dark: '#60A5FA',
    light: '#6B7280',
  },
  primary: '#10B981',
};
